const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchBlogList = async () => {
  const r = await fetch(`${API}/blog`);
  if (!r.ok) throw new Error("blog list failed");
  return r.json();
};

export const fetchBlogArticle = async (slug) => {
  const r = await fetch(`${API}/blog/${encodeURIComponent(slug)}`);
  if (r.status === 404) return null;
  if (!r.ok) throw new Error("blog article failed");
  return r.json();
};

export const formatBlogDate = (iso, lang) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(lang === "fr" ? "fr-FR" : "en-GB", { year: "numeric", month: "long", day: "numeric" });
};

export const BLOG_COPY = {
  en: {
    seoTitle: "Blog — Personal Assistant & Private Concierge, Paris | Book & Smile",
    seoDesc: "Articles on personal assistance, private concierge and lifestyle management in Paris for international clients. Published by Book & Smile.",
    eyebrow: "The Blog",
    title: "Notes from Paris.",
    intro: "Articles on personal assistance, private concierge and life in France, written for international clients.",
    read: "Read the article",
    empty: "The first articles are being prepared.",
    home: "Home",
    blog: "Blog",
    notFoundTitle: "This article is not available.",
    notFoundText: "It may have been moved or withdrawn.",
    back: "Back to the blog",
    ctaLabel: "Request a Private Consultation",
    more: "More articles",
    loading: "Loading",
  },
  fr: {
    seoTitle: "Blog — Assistant personnel & conciergerie privée, Paris | Book & Smile",
    seoDesc: "Articles sur l'assistance personnelle, la conciergerie privée et le lifestyle management à Paris pour une clientèle internationale. Par Book & Smile.",
    eyebrow: "Le Blog",
    title: "Notes de Paris.",
    intro: "Articles sur l'assistance personnelle, la conciergerie privée et la vie en France, écrits pour une clientèle internationale.",
    read: "Lire l'article",
    empty: "Les premiers articles sont en préparation.",
    home: "Accueil",
    blog: "Blog",
    notFoundTitle: "Cet article n'est pas disponible.",
    notFoundText: "Il a peut-être été déplacé ou retiré.",
    back: "Retour au blog",
    ctaLabel: "Demander une consultation privée",
    more: "Autres articles",
    loading: "Chargement",
  },
};
